/*
* @Author: gujianghua
* @Date:   2018-06-27 10:56:46
* @Last Modified by:   gujianghua
* @Last Modified time: 2018-08-16 16:41:04
*/
import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import tabs from './modules/tabs'
import bigPic from './modules/bigPic'

Vue.use(Vuex)

const store = new Vuex.Store({
	modules: {
		user,
		tabs,
		bigPic
	}
})

export default store


// WEBPACK FOOTER //
// ./src/store/index.js